import { graphql } from 'gatsby';
import { withPrismicUnpublishedPreview } from 'gatsby-plugin-prismic-previews';
import React from 'react';

import { Page404 } from '../components/Page404';
import SliceZone from '../components/SliceZone';

const Custom404 = ({ data, pageContext, location }) => {
  const hasValidBodyContent = data?.prismicPage?.data?.body?.some(
    (slice) => slice && Object.keys(slice).length > 0
  );

  if (hasValidBodyContent) {
    const { body, slug } = data.prismicPage.data;
    return (
      <SliceZone
        slices={body}
        slug={slug}
        location={location}
        pageContext={pageContext}
      />
    );
  }

  return <Page404 pageContext={pageContext} />;
};

export default withPrismicUnpublishedPreview(Custom404);

export const query = graphql`
  query Custom404Query($siteTag: String!) {
    prismicPage(tags: { eq: $siteTag }, data: { slug: { eq: "/404-page" } }) {
      _previewable
      data {
        slug
        locale
        seo_title
        seo_description
        no_index
        body {
          ... on PrismicPageDataBodyBlock404 {
            slice_type
            primary {
              title {
                richText
              }
              description {
                richText
              }
            }
          }
          ... on PrismicPageDataBodyBlockFindYourGhostKitchen {
            id
            slice_label
            slice_type
            primary {
              button_text {
                text
              }
              typeform_button
              title {
                richText
              }
              paragraph {
                richText
              }
              search_placeholder
              facility
              facilities
              delivery
              takeout
            }
            items {
              title {
                richText
              }
              number_of_facilities
              region
              link {
                url
              }
              item_image {
                gatsbyImageData(width: 700)
              }
            }
          }
        }
      }
    }
  }
`;
